module.exports = __webpack_public_path__ + "static/custom-bedding-3b504ef6ae344236a43af131e9b456b3.png";